import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';

import MainDrawer from '../../components/mainDrawer';
import MainDrawerMobile from '../../components/mainDrawerMobile'
import MainAppBar from '../../components/MainAppBar/MainAppBar';
import MainAppBarMobile from '../../components/MainAppBar/MainAppBarMobile';

import TermsAndConditionsReadOnly from "../../components/TermsAndConditions/TermsAndConditionsReadOnly";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../features/auth/authSlice";

const Dashboard = () => {
  const user = useSelector(selectCurrentUser);
  const [width, setWidth] = useState(window.innerWidth);
  const [showTermsAndConditions, setShowTermsAndConditions] = useState(false);
  const [drawerState, setDrawerState] = useState(false);

  const updateDimensions = () => {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <Box sx={{ display: 'flex' }}>
      {width > 765 ? (
        <>
          <MainAppBar />
          <MainDrawer user={user} />
        </>
      ) : (
        <>
          <MainAppBarMobile drawerState={drawerState} setDrawerState={setDrawerState} />
          <MainDrawerMobile 
            user={user} 
            drawerState={drawerState} 
            setDrawerState={setDrawerState} 
            openTermsAndCondtions={() => setShowTermsAndConditions(true)} 
          />
        </>
      )}
      <TermsAndConditionsReadOnly 
        open={showTermsAndConditions} 
        handleClose={() => setShowTermsAndConditions(false)}
      />
    </Box>
  );
};

export default Dashboard;
